module.exports = __webpack_public_path__ + "static/media/satria-staff-web-hubton.7a51c66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/satria-staff-web-hubton.png
// module id = 180
// module chunks = 0